import { CREATE_LEAD_REQUEST, CREATE_LEAD_SUCCESS, CREATE_LEAD_FAILURE } from '../constants/create_lead.constants';

export const createLeadRequest = params => ({
    type: CREATE_LEAD_REQUEST,
    params,
});

export const createLeadSuccess = payload => ({
    type: CREATE_LEAD_SUCCESS, payload,
});

export const createLeadFailure = error => ({
    type: CREATE_LEAD_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/actions/create_lead.actions.js